/**
 * Download a generated PDF (a Document `link`) under a readable filename: fetch → blob → a
 * temporary `<a download>`, falling back to opening the link in a new tab when the fetch fails
 * (CORS, a non-2xx from the bucket, a browser without Blob URLs) so the operator can still print.
 *
 * Copied from SalesOrderPicking's picking-slip helper, `response.ok` check included — without it
 * an expired signed URL downloads the bucket's XML error page as "Invoice.pdf". The Option-1
 * pages (SalesOrderPicking, SalesOrderDocuments) keep their own copies untouched; this shared one
 * is for the Pick → Verify → Ship screens.
 */
const downloadFile = async (url: string, filename: string): Promise<void> => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Download failed (${response.status})`);
    const buf = await response.arrayBuffer();
    const blob = new Blob([buf], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl);
  } catch {
    window.open(url, '_blank');
  }
};

export default downloadFile;
